(function () {
  "use strict";

  function initTopbarSliders() {
    var sliders = document.querySelectorAll("[data-topbar-slider]");

    sliders.forEach(function (slider) {
      var slides = slider.querySelectorAll(".topbar__slide");
      if (slides.length <= 1) return;

      var speed = parseInt(slider.dataset.speed, 10) || 5000;
      var activeIndex = 0;
      var timer = null;

      var prevBtn = slider.querySelector(".topbar__slider-btn--prev");
      var nextBtn = slider.querySelector(".topbar__slider-btn--next");

      function goTo(index) {
        slides[activeIndex].classList.remove("is-active");
        activeIndex = (index + slides.length) % slides.length;
        slides[activeIndex].classList.add("is-active");
      }

      function next() {
        goTo(activeIndex + 1);
      }

      function prev() {
        goTo(activeIndex - 1);
      }

      function startTimer() {
        timer = setInterval(next, speed);
      }

      function stopTimer() {
        clearInterval(timer);
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", function () {
          stopTimer();
          next();
          startTimer();
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener("click", function () {
          stopTimer();
          prev();
          startTimer();
        });
      }

      slider.addEventListener("mouseenter", stopTimer);
      slider.addEventListener("mouseleave", startTimer);

      startTimer();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initTopbarSliders);
  } else {
    initTopbarSliders();
  }

  // Re-initialize when Shopify theme editor loads the section
  document.addEventListener("shopify:section:load", function (event) {
    if (event.target.querySelector("[data-topbar-slider]")) {
      initTopbarSliders();
    }
  });
})();
